<template>
    <div>
        <ssams-filter-link
            :filterLayout="filterLayout"
            :filterData="filterSet.filter"
            :paginationData="filterSet.page"
        ></ssams-filter-link>
        <ssams-list-link
            :listLayout="listLayout"
            :paginationData="filterSet.page"
            :ssamsData="List"
        ></ssams-list-link>
        <pagination-link
            :paginationLayout="paginationLayout"
            :paginationData="filterSet.page"
        ></pagination-link>
    </div>
</template>

<script>
import SsamsFilterLink from "@/components/ssams/link/SsamsFilterLink";
import SsamsListLink from "@/components/ssams/link/SsamsListLink";
import PaginationLink from "@/components/ssams/link/PaginationLink";
import ssamsUtil from "@/components/ssams/ssamsUtil";
import filterMixins from "@/mixins/filterMixins";
import listMixins from "@/mixins/listMixins";
import alertMixins from "@/mixins/alertMixins";
import util from "@/mixins/util";
import EventBus from "@/utils/event-bus";
import DeleteClass from "@/mixins/deleteClass";

const {filterConfig} = ssamsUtil;

export default {
    name: "SsamsListComponent",
    mixins: [ssamsUtil, filterMixins, listMixins, alertMixins],
    components: {SsamsFilterLink, SsamsListLink, PaginationLink},
    provide() {
        return {
            setPage: this.setPage,
            setFilter: this.setFilter,
            setSort: this.setSort,
            ssamsListSetData: this.setData,
            ssamsListDelete: this.runDeleteConfirm,
            mcChangeFunc: this.mcValueChangeFunc,
        };
    },
    inject: ['mcValueChange'],
    props: {
        ssamsType: {default: ""},
        ssamsKey: "",
        userKey: ""
    },
    data() {
        return {
            filterLayout: "",
            listLayout: "",
            paginationLayout: "",

            getFunc: "",
            listApiParamSet: {},
            pageRow: 10,
            paginationType: "",
            isCategory: false,

            keyName: "",
            deleteFunc: "",
            deleteApiParamSet: {},
            deleteSuccessType: 1,
            deleteFailTypes: {},
        };
    },
    created() {
        this.initConfig();
        this.setFilterConfig(filterConfig);
        this.setParserType("url", this.$route.fullPath);
    },
    mounted() {
        this.getList(true);
        if (!util.isEmpty(this.ssamsKey)) {
            this.getSsamsBoard(this.ssamsType);
        }
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        setData(type, value) {
            this[type] = value;
        },
        initConfig() {
            let config = this.returnSsamsConfig(this.ssamsType);
            this.listLayout = config.listLayout;
            this.filterLayout = config.filterLayout;
            this.paginationLayout = config.paginationLayout;

            this.getFunc = config.getFunc;
            this.listApiParamSet = config.listApiParamSet;
            this.pageRow = config.pageRow;
            this.paginationType = config.paginationType;
            this.isCategory = config.isCategory;

            this.keyName = config.keyName;
            this.deleteFunc = config.deleteFunc;
            this.deleteApiParamsSet = config.deleteApiParamsSet;
            this.deleteSuccessType = config.deleteSuccessType;
            this.deleteFailTypes = config.deleteFailTypes;
            this.deleteAlertText = config.deleteAlertText;
            this.deleteSuccessAlertText = config.deleteSuccessAlertText;
            if (!util.isEmpty(this.ssamsKey)) {
                this.listApiParamSet.sid = this.ssamsKey;
                this.listApiParamSet.mbno = this.userKey;
            }
            if (config.pageRow && config.pageRow !== this.filterSet.page.size) {
                this.pageRow = config.pageRow;
                this.filterSet.page.size = config.pageRow;
                this.pageClass.setterPage("size", this.pageRow);
            }

            let listOptions = {
                url: this.$api.$ssams[this.getFunc],
                defaultParams: this.listApiParamSet,
            };

            this.initList("api", listOptions);
            this.newDeleteClass();
        },
        newDeleteClass() {
            if (!util.isEmpty(this.deleteFunc)) {
                let deleteOptions = {
                    func: this.$api.$ssams[this.deleteFunc],
                    apiParamSet: this.deleteApiParamsSet,
                    keyName: this.keyName,
                    successType: this.deleteSuccessType,
                    errorTypes: this.deleteFailTypes,
                    afterFunc: this.deleteAfterFunc,
                };
                this.DeleteClass = new DeleteClass(deleteOptions);
            }
        },
        runDeleteConfirm(key, parent) {
            this.createConfirm({
                content: "정말 삭제하시겠습니까?",
                confirm: () => {
                    this.setDeleteKey(key, parent);
                },
            });
        },
        setDeleteKey(key, parent) {
            this.runDelete(key, parent);
        },
        runDelete(key, parent) {
            EventBus.$emit("apiLoading", true);
            this.DeleteClass.runDelete(key, parent);
        },
        deleteAfterFunc() {
            EventBus.$emit("apiLoading", false);

            this.createAlert({
                content: "삭제되었습니다.",
                hide: () => {
                    this.getList();
                },
            });
        },

        getSsamsBoard(type) {
            let params = {
                sid: this.ssamsKey,
                mbno: this.userKey
            };
            try {
                this.$api.$ssams
                    .type(params)
                    .then((result) => result.Data.Result)
                    .then((res) => {
                        if (res.Info.type !== 1) {
                            this.errorAlert("회원정보를 불러올 수 없습니다.");
                        } else {
                            this.ssamsData = res.List[0];
                        }
                    });
            } catch (e) {
            }
        },
        mcValueChangeFunc(key,value) {
            this.mcValueChange(key,value);
        }
    },
    watch: {},
};
</script>

<style scoped></style>
